module.exports = __webpack_public_path__ + "static/media/GroupTana.12609529.jpg";